interface StatusBadgeProps {
  status: string
  type?: 'default' | 'obra' | 'req' | 'conta' | 'oc' | 'cotacao'
}

const statusColors: Record<string, string> = {
  ATIVO: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/20',
  ATIVA: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/20',
  INATIVO: 'bg-[rgba(255,255,255,0.05)] text-[#8a8f98] border-[rgba(255,255,255,0.08)]',
  INATIVA: 'bg-[rgba(255,255,255,0.05)] text-[#8a8f98] border-[rgba(255,255,255,0.08)]',
  BLOQUEADO: 'bg-red-500/15 text-red-400 border-red-500/20',
  EM_ANDAMENTO: 'bg-blue-500/15 text-blue-400 border-blue-500/20',
  PLANEJADA: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/20',
  CONCLUIDA: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/20',
  PARALISADA: 'bg-red-500/15 text-red-400 border-red-500/20',
  RASCUNHO: 'bg-[rgba(255,255,255,0.05)] text-[#8a8f98] border-[rgba(255,255,255,0.08)]',
  ENVIADA: 'bg-blue-500/15 text-blue-400 border-blue-500/20',
  EM_APROVACAO: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/20',
  APROVADA: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/20',
  REJEITADA: 'bg-red-500/15 text-red-400 border-red-500/20',
  EM_COTACAO: 'bg-purple-500/15 text-purple-400 border-purple-500/20',
  CONVERTIDA_OC: 'bg-indigo-500/15 text-indigo-400 border-indigo-500/20',
  CANCELADA: 'bg-[rgba(255,255,255,0.05)] text-[#62666d] border-[rgba(255,255,255,0.06)]',
  CANCELADO: 'bg-[rgba(255,255,255,0.05)] text-[#62666d] border-[rgba(255,255,255,0.06)]',
  PREVISTO: 'bg-[rgba(255,255,255,0.05)] text-[#8a8f98] border-[rgba(255,255,255,0.08)]',
  PROVISIONADO: 'bg-blue-500/15 text-blue-400 border-blue-500/20',
  PENDENTE: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/20',
  PAGO: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/20',
  PARCIALMENTE_PAGO: 'bg-orange-500/15 text-orange-400 border-orange-500/20',
  ATRASADO: 'bg-red-500/15 text-red-400 border-red-500/20',
  EM_APROVACAO_OC: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/20',
  EMITIDA: 'bg-blue-500/15 text-blue-400 border-blue-500/20',
  PARCIALMENTE_RECEBIDA: 'bg-orange-500/15 text-orange-400 border-orange-500/20',
  RECEBIDA: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/20',
  ABERTA: 'bg-blue-500/15 text-blue-400 border-blue-500/20',
  EM_ANALISE: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/20',
  PENDENTE_AP: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/20',
  APROVADO: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/20',
  REJEITADO: 'bg-red-500/15 text-red-400 border-red-500/20',
}

const statusLabels: Record<string, string> = {
  EM_ANDAMENTO: 'Em Andamento',
  EM_APROVACAO: 'Em Aprovacao',
  EM_COTACAO: 'Em Cotacao',
  EM_ANALISE: 'Em Analise',
  CONVERTIDA_OC: 'Conv. OC',
  PARCIALMENTE_RECEBIDA: 'Parc. Recebida',
  PARCIALMENTE_PAGO: 'Parc. Pago',
  SERVICO_TERCEIRIZADO: 'Serv. Terceirizado',
  CUSTO_INDIRETO: 'Custo Indireto',
  MAO_DE_OBRA: 'Mao de Obra',
  LANCAMENTO_MANUAL_CONTROLADO: 'Lancamento Manual',
  ORDEM_COMPRA: 'Ordem de Compra',
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const colorClass = statusColors[status] || 'bg-[rgba(255,255,255,0.05)] text-[#8a8f98] border-[rgba(255,255,255,0.08)]'
  const label = statusLabels[status] || status.replace(/_/g, ' ')

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border ${colorClass}`}>
      {label}
    </span>
  )
}

